import { normalizeCohortEntity } from './normalize/cohort';
import { normalizeSessionEntity } from './normalize/session';

export function mergeCohortsForDisplay(schoolCohortsMap, cohorts, cohortsFetch) {
  const schoolBuilt = Object.values(schoolCohortsMap).flat();
  const schoolIds = new Set(schoolBuilt.map(c => c.id));
  let merged = [...cohorts.filter(c => !schoolIds.has(c.id)), ...schoolBuilt];

  if (merged.length === 0 && cohortsFetch?.status === 'success' && cohortsFetch.data?.length > 0) {
    merged = cohortsFetch.data.map(cohort => normalizeCohortEntity(cohort)).filter(Boolean);
  }

  return merged;
}

export function mergeSessionsForDisplay(sessionsState, sessionsFetch, workspaceSessions = null) {
  let base = workspaceSessions ?? sessionsState;

  if (base.length === 0 && sessionsFetch?.status === 'success' && sessionsFetch.data?.length > 0) {
    base = sessionsFetch.data.map(session => normalizeSessionEntity(session)).filter(Boolean);
  }

  return base;
}